module.exports = __webpack_public_path__ + "media/components/directory/assets/new-logo-6abc736ab790739e2a09b9aec6ffd85c.svg";